/* ── Danh sách quà đã lưu ────────────────────────────────────────────────────
   Lưu bằng localStorage, không cần tài khoản, không cần app.

   Chỉ lưu HANDLE của sản phẩm, không lưu tên/ảnh/giá. Hai lý do: giá và ảnh đổi
   theo thời gian nên bản sao trong máy khách sẽ sai dần, và handle là thứ duy
   nhất đủ để hỏi lại Shopify toàn bộ phần còn lại qua /products/{handle}.js.

   GIỚI HẠN, ghi ra đây để sau không ai tưởng nhầm: dữ liệu nằm trên ĐÚNG trình
   duyệt đó. Đổi máy, đổi trình duyệt, hay xoá dữ liệu duyệt web là mất. Muốn
   theo tài khoản và gửi được email nhắc lại thì phải có app hoặc backend.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var KHOA = 'cg:wishlist';

  function doc() {
    try {
      var raw = window.localStorage.getItem(KHOA);
      var ds = raw ? JSON.parse(raw) : [];
      return Array.isArray(ds) ? ds.filter(function (x) { return typeof x === 'string' && x; }) : [];
    } catch (e) {
      /* Chế độ riêng tư của Safari ném lỗi ngay ở getItem. Không để cả tính năng
         chết theo — trả về danh sách rỗng và các nút vẫn bấm được, chỉ là không
         nhớ được sau khi tải lại. */
      return [];
    }
  }

  function ghi(ds) {
    try {
      window.localStorage.setItem(KHOA, JSON.stringify(ds));
      return true;
    } catch (e) {
      return false;
    }
  }

  function co(handle) {
    return doc().indexOf(handle) > -1;
  }

  function bat(handle) {
    var ds = doc();
    var i = ds.indexOf(handle);
    if (i > -1) ds.splice(i, 1);
    else ds.unshift(handle); /* mới lưu lên đầu */
    ghi(ds);
    return i === -1;
  }

  function dongBo(nut) {
    var handle = nut.getAttribute('data-product-handle');
    if (!handle) return;
    nut.setAttribute('aria-pressed', co(handle) ? 'true' : 'false');
  }

  function dongBoTatCa() {
    var ds = document.querySelectorAll('[data-cg-save]');
    for (var i = 0; i < ds.length; i++) dongBo(ds[i]);
  }

  document.addEventListener('click', function (event) {
    var nut = event.target.closest ? event.target.closest('[data-cg-save]') : null;
    if (!nut) return;
    var handle = nut.getAttribute('data-product-handle');
    if (!handle) return;
    bat(handle);
    dongBo(nut);
  });

  /* Hai tab cùng mở: tab kia lưu thì tab này cập nhật theo. Sự kiện storage chỉ
     bắn sang CÁC tab khác, không bắn cho tab vừa ghi — nên không có vòng lặp. */
  window.addEventListener('storage', function (event) {
    if (event.key === KHOA) dongBoTatCa();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dongBoTatCa);
  } else {
    dongBoTatCa();
  }

  /* Trang danh sách quà đọc qua đây. Giữ bề mặt nhỏ nhất có thể. */
  window.cgWishlist = { doc: doc, co: co, bat: bat, dongBoTatCa: dongBoTatCa, KHOA: KHOA };

  /* ── Dựng trang danh sách quà ──────────────────────────────────────────────
     Chỉ chạy trên đúng trang đó. Hỏi Shopify từng handle qua /products/x.js —
     endpoint công khai, trả JSON, không cần token.

     Hỏi SONG SONG chứ không lần lượt: 12 món lấy tuần tự là 12 vòng khứ hồi nối
     đuôi nhau. Promise.all gộp lại còn một nhịp chờ.

     Handle nào trả về lỗi thì LOẠI KHỎI danh sách luôn: sản phẩm đã bị gỡ hoặc
     đổi tên, giữ lại chỉ để lần sau lại hỏi lại và lại hỏng. */
  function dungTrang() {
    var khung = document.querySelector('[data-cg-wishlist-page]');
    if (!khung) return;

    var luoi = khung.querySelector('[data-cg-wishlist-grid]');
    var rong = khung.querySelector('[data-cg-wishlist-empty]');
    var dem = khung.querySelector('[data-cg-wishlist-count]');
    var ds = doc();

    if (!ds.length) {
      if (dem) dem.textContent = '';
      return;
    }

    Promise.all(
      ds.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (sp) {
      var con = [];
      var hong = [];
      sp.forEach(function (p, i) {
        if (p) con.push(p);
        else hong.push(ds[i]);
      });

      if (hong.length) ghi(ds.filter(function (h) { return hong.indexOf(h) === -1; }));

      if (!con.length) {
        if (dem) dem.textContent = '';
        return;
      }

      if (rong) rong.hidden = true;
      if (dem) dem.textContent = con.length === 1 ? '1 gift saved' : con.length + ' gifts saved';

      luoi.innerHTML = '';
      con.forEach(function (p) {
        var anh = p.featured_image || (p.images && p.images[0]) || '';
        var li = document.createElement('li');
        li.className = 'wishlist-card';
        li.innerHTML =
          '<a class="wishlist-card__link" href="/products/' + p.handle + '">' +
          (anh ? '<img class="wishlist-card__image" src="' + anh + '&width=480" alt="" loading="lazy" width="240" height="240">' : '') +
          '<span class="wishlist-card__title"></span>' +
          '<span class="wishlist-card__price"></span>' +
          '</a>' +
          '<button type="button" class="wishlist-card__remove" data-cg-save data-product-handle="' + p.handle + '" aria-pressed="true" aria-label="Remove from gift list">' +
          'Remove</button>';
        /* Tên và giá gán bằng textContent chứ không nhét vào chuỗi HTML: tên sản
           phẩm do người nhập, có dấu nháy và ký tự đặc biệt. */
        li.querySelector('.wishlist-card__title').textContent = p.title;
        li.querySelector('.wishlist-card__price').textContent = (p.price / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD',
        });
        luoi.appendChild(li);
      });
      luoi.hidden = false;
    });
  }

  /* Bỏ một món ngay trên trang danh sách thì phải rút thẻ đó khỏi lưới luôn —
     nút chuyển sang trạng thái "chưa lưu" mà thẻ vẫn nằm đó là nói dối. */
  document.addEventListener('click', function (event) {
    var nut = event.target.closest ? event.target.closest('.wishlist-card__remove') : null;
    if (!nut) return;
    var the = nut.closest('.wishlist-card');
    if (the) the.remove();
    var luoi = document.querySelector('[data-cg-wishlist-grid]');
    var rong = document.querySelector('[data-cg-wishlist-empty]');
    var dem = document.querySelector('[data-cg-wishlist-count]');
    var con = luoi ? luoi.children.length : 0;
    if (dem) dem.textContent = con === 0 ? '' : con === 1 ? '1 gift saved' : con + ' gifts saved';
    if (con === 0) {
      if (luoi) luoi.hidden = true;
      if (rong) rong.hidden = false;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dungTrang);
  } else {
    dungTrang();
  }
})();
